import classNames from 'classnames';
import React, { forwardRef } from 'react';
import BaseCallout from './BaseCallout';
import { ReactComponent as InfoIcon } from '@/assets/svgs/icon-info-outlined.svg';
import { ReactComponent as WarningIcon } from '@/assets/svgs/icon-warning-circle.svg';
import { ReactComponent as ErrorIcon } from '@/assets/svgs/icon-error-message-exclamation.svg';
import PropTypes from 'prop-types';

const calloutProperties = {
    'INFO': {
        'STANDARD': {
            className: 'DS__callout-info DS__callout-info--standard'
        },
        'FILLED': {
            className: 'DS__callout-info DS__callout-info--filled'
        },
        'OUTLINED': {
            className: 'DS__callout-info DS__callout-info--outlined'
        }
    },
    'WARNING': {
        'STANDARD': {
            className: 'DS__callout-warning DS__callout-warning--standard'
        },
        'FILLED': {
            className: 'DS__callout-warning DS__callout-warning--filled'
        },
        'OUTLINED': {
            className: 'DS__callout-warning DS__callout-warning--outlined'
        }
    },
    'ERROR': {
        'STANDARD': {
            className: 'DS__callout-error DS__callout-error--standard'
        },
        'FILLED': {
            className: 'DS__callout-error DS__callout-error--filled'
        },
        'OUTLINED': {
            className: 'DS__callout-error DS__callout-error--outlined'
        }
    }
};

const defaultIcons = {
    'INFO': <InfoIcon />,
    'WARNING': <WarningIcon />,
    'ERROR': <ErrorIcon />
};

const Callout = forwardRef((props, ref) => {
    const { 
        dataTestId = 'callout', 
        type, 
        variant,
        message, 
        onClick, 
        disabled, 
        icon,
        className: userClassName,
        ...calloutProps 
    } = props;

    const calloutConfig = calloutProperties[type]?.[variant];

    if (!calloutConfig) {
        return null;
    }

    const { className } = calloutConfig;

    const calloutClass = classNames('DS__callout', className, userClassName, {
        'DS__callout--disabled': disabled
    });

    const iconToUse = icon || defaultIcons[type];

    return (
        <BaseCallout
            ref={ref}
            dataTestId={dataTestId}
            message={message}
            icon={iconToUse}
            onClick={onClick}
            calloutClassName={calloutClass}
            disabled={disabled}
            calloutType={type}
            {...calloutProps}
        />
    );
});

Callout.displayName = 'Callout';

Callout.propTypes = {
    dataTestId: PropTypes.string,
    type: PropTypes.oneOf(['INFO', 'WARNING', 'ERROR']),
    variant: PropTypes.oneOf(['STANDARD', 'FILLED', 'OUTLINED']),
    message: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    className: PropTypes.string,
};

export default Callout;
